// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";  

const firebaseConfig = {
  apiKey: "AIzaSyD4YLTlazfCjihrEcSMyIOiAzKmDp16Zn4",
  authDomain: "tarefas-b067a.firebaseapp.com",
  projectId: "tarefas-b067a",
  storageBucket: "tarefas-b067a.firebasestorage.app",
  messagingSenderId: "510172124274",
  appId: "1:510172124274:web:d5017d5c1e2cef6ea81eeb",
  measurementId: "G-LT9CNN0P1H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app)

export {db, auth};
 